<template>
    <div class="ut-amount-input" :class="{'is-bare': !store.hasStoredPaymentMethods}">
        <label>

            <span v-show="store.isAmountUpdatable">
                Amount
            </span>

            <currency-input
                v-model="amountDollars"
                :options="{ currency: 'USD', precision: 2, autoDecimalDigits: true }"
                :disabled="isAmountDisabled"
                :class="{'is-editable': store.isAmountUpdatable}"
            />
        </label>
    </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import { useStore } from '@/store/store'
import CurrencyInput from '@/components/ut-currency-input/ut-currency-input.vue'

export default defineComponent({
    name: 'ut-amount-section',
    components: { CurrencyInput },

    computed: {
        /**
         * Application store.
         */
        store() {
            return useStore()
        },
        amountDollars: {
            // getter
            get() {
                return this.store.amount / 100.00
            },
            // setter
            set(newValue: number) {
                this.store.amount = newValue * 100
            },
        },
        isAmountDisabled() {
            return !this.store.isAmountUpdatable
        },
    },
})
</script>

<style scoped lang="scss">

.ut-amount-input {
    border-bottom: 1px solid #e6e6e6;
    padding: 1.5rem;

    &.is-bare {
        border-bottom: none;
    }

    input {
        border: 0;
        display: block;
        font-size: 1.5rem;
        line-height: 2rem;
        margin-top: 0.25rem;
        text-align: center;
        width: 100%;
    }

    input.is-editable {
        border: 1px solid #e6e6e6;
        border-radius: .25rem;
        box-shadow: 0 1px 1px rgba(0, 0, 0, 0.03), 0 3px 6px rgba(0, 0, 0, 0.02);
    }

    span {
        color: #30313d;
        font-family: -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Oxygen, Ubuntu, Cantarell, Open Sans, Helvetica Neue, sans-serif;
        font-size: 0.93rem;
        line-height: 1.25rem;
        -moz-osx-font-smoothing: grayscale;
        -webkit-font-smoothing: antialiased;
    }
}

</style>
